import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const RIGHTSIZING_PATCH_SCRIPT_QUERY_KEY = 'rightsizing-patch-script';

const getRightsizingPatchScriptQueryKey = ({
  clusterId,
  namespace,
  workloadName,
  workloadType,
}: Partial<Props> = {}) =>
  [
    RIGHTSIZING_PATCH_SCRIPT_QUERY_KEY,
    ...(clusterId !== undefined
      ? [clusterId, namespace, workloadName, workloadType]
      : []),
  ] as const;

type Props = {
  clusterId: string;
  namespace: string;
  workloadName: string;
  workloadType: string;
  enabled?: boolean;
};

const getRightsizingPatchScriptQueryOptions = ({
  clusterId,
  namespace,
  workloadName,
  workloadType,
  enabled = true,
}: Props) =>
  queryOptions({
    queryKey: getRightsizingPatchScriptQueryKey({
      clusterId,
      namespace,
      workloadName,
      workloadType,
    }),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getRightsizingPatchScript({
        clusterId,
        workloads: {
          workloads: [
            {
              namespace,
              workloadName,
              workloadType,
            },
          ],
        },
      });
      return data;
    },
    enabled,
  });

export const useRightsizingPatchScriptQuery = (props: Props) => {
  const { isLoading, data, error, refetch } = useQuery(
    getRightsizingPatchScriptQueryOptions(props)
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
